import React from 'react';
import { useMediaQuery } from 'react-responsive';
import ButtonGroup from 'devextreme-react/button-group';

const DateFilter = ({ onFilterChange, selectedFilter, mFilter }) => {
  const filters = ['1W', '1M', '1Q', '1Y', '2Y'];
  const isMobile = useMediaQuery({ maxWidth: 767 });

  return (
    <ButtonGroup
      items={filters.map((text) => ({ text }))}
      keyExpr="text"
      selectedItemKeys={selectedFilter ? [selectedFilter] : [mFilter]} // Ensure correct selection
      onItemClick={(e) => onFilterChange(e.itemData.text)} // Pass the clicked filter directly
      stylingMode="outlined"
      selectionMode="single"
      className={`w-auto ${isMobile ? 'w-[20%]' : ''}`}
    />
  );
};

export default DateFilter;
